import { differenceInSeconds, format, formatDistanceToNow, isToday, isYesterday } from 'date-fns';
import { capitalize } from 'lodash-es';

export const formatNotificationDate = (date: Date): string => {
  const now = new Date();
  const secondsAgo = differenceInSeconds(now, date);

  if (secondsAgo < 60) {
    return 'Just now';
  }

  if (isToday(date)) {
    return capitalize(formatDistanceToNow(date, { addSuffix: true }));
  }
  if (isYesterday(date)) {
    return `Yesterday, ${format(date, 'h:mm a')}`;
  }
  return format(date, 'MMM d, h:mm a');
};
